/**
 * Created by alvinoktavianus on 5/9/17.
 */

import {
  SETTING_BILLING_BILLINGS,
  SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
  SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
  SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_ON_CLICK_TURN_BUTTON,
  SETTING_BILLING_PAGE_REQUEST,
  SETTING_BILLING_PAY_BUTTON_MESSAGE,
  SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
  SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_BILLINGS,
  SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
  SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
  SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
  SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS,
  SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION,
  SETTING_BILLING_SET_IS_DELETED_OUTLET,
  SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
  SETTING_BILLING_SET_OUTLETS,
  SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
  SETTING_BILLING_SET_RULES,
  SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
  SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
  SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
  SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  SETTING_BILLING_VERIFY_BILLING_COUPON,
  SETTING_BILLING_SET_STATUS_VALIDATION_COUPON,
  SETTING_BILLING_SET_COUPON_DISCOUNT,
  SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST,
  SETTING_BILLING_SET_COUPON_ERROR_MESSAGE,
  SETTING_BILLING_IS_VALIDATING_COUPON,
  SETTING_BILLING_SET_PURCHASED_STAFFS,
  SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS,
  SETTING_BILLING_SET_SEPARATE_OUTLET,
  SETTING_BILLING_SET_EXTEND_DATE,
  SETTING_BILLING_SET_PROGRESS_CURSOR,
  SETTING_BILLING_SHOW_PRORATE_TEXT,
  SETTING_BILLING_EXPIRED_DATE,
  SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL,
  SETTING_BILLING_SET_TOTAL_OUTLET_PRICE,
  SETTING_BILLING_SET_TOTAL_FEATURES_PRICE,
  SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT,
  SETTING_BILLING_SEND_CLEVERTAP,
  SETTING_BILLING_SET_PRORATE_PRICE_PERIODS,
  SETTING_BILLING_SET_STAFF_SLOTS_PRICE,
  SETTING_BILLING_VERIFY_BILLING_COUPON_V2,
} from './constant';

export function billingPageRequest(
  currentPlan,
  expired,
  isOwner,
  billingNotification
) {
  return {
    type: SETTING_BILLING_PAGE_REQUEST,
    payload: { currentPlan, expired, isOwner, billingNotification },
  };
}

export function rulesOutletsSubscriptionStatus(
  currentPlan,
  expired,
  isTrial,
  outletSlot
) {
  return {
    type: SETTING_BILLING_RULES_OUTLETS_SUBSCRIPTION_RULES,
    payload: { currentPlan, expired, isTrial, outletSlot },
  };
}

export function billings() {
  return {
    type: SETTING_BILLING_BILLINGS,
  };
}

export function setBillings(data) {
  return {
    type: SETTING_BILLING_SET_BILLINGS,
    payload: { data },
  };
}

export function setOutlets(data) {
  return {
    type: SETTING_BILLING_SET_OUTLETS,
    payload: { data },
  };
}

export function setRules(data) {
  return {
    type: SETTING_BILLING_SET_RULES,
    payload: { data },
  };
}

export function setSubscriptionStatus(data) {
  return {
    type: SETTING_BILLING_SET_SUBSCRIPTION_STATUS,
    payload: { data },
  };
}

export function onChangeSubscriptionRules(
  subscriptionRules,
  outletMinMaxDate,
  minMaxAllOutlet
) {
  return {
    type: SETTING_BILLING_ON_CHANGE_SUBSCRIPTION_RULES,
    payload: { subscriptionRules, outletMinMaxDate, minMaxAllOutlet },
  };
}

export function setCurrentSubscriptionRules(newSubscriptionRules) {
  return {
    type: SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_RULES,
    payload: { newSubscriptionRules },
  };
}

export function payMokaSubscription(
  totalPrice,
  subscriptionPlan,
  purchasedOutlets,
  activatedFeatures,
  couponDiscount,
  couponDiscountRequest,
  isExtendedStaffSlots
) {
  return {
    type: SETTING_BILLING_PAY_MOKA_SUBSCRIPTION,
    payload: {
      totalPrice,
      subscriptionPlan,
      purchasedOutlets,
      activatedFeatures,
      couponDiscount,
      couponDiscountRequest,
      isExtendedStaffSlots,
    },
  };
}

export function isClickedPayButton(payButtonClicked) {
  return {
    type: SETTING_BILLING_IS_CLICKED_BUTTON_PAY,
    payload: { payButtonClicked },
  };
}

export function payButtonMessage(payButtonMessage) {
  return {
    type: SETTING_BILLING_PAY_BUTTON_MESSAGE,
    payload: { payButtonMessage },
  };
}

export function showPaymentGatewayErrorModal() {
  return {
    type: SETTING_BILLING_SHOW_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}

export function hidePaymentGatewayErrorModal() {
  return {
    type: SETTING_BILLING_HIDE_PAYMENT_GATEWAY_ERROR_MODAL,
  };
}

export function setTotalBillingPrice(totalBillingPrice) {
  return {
    type: SETTING_BILLING_SET_TOTAL_BILLING_PRICE,
    payload: { totalBillingPrice },
  };
}

export function setPendingPaymentMessage(pendingPaymentMessage) {
  return {
    type: SETTING_BILLING_SET_PENDING_PAYMENT_MESSAGE,
    payload: { pendingPaymentMessage },
  };
}

export function setUnusedOutletMessage(unusedOutletMessage) {
  return {
    type: SETTING_BILLING_SET_UNUSED_OUTLETS_MESSAGE,
    payload: { unusedOutletMessage },
  };
}

export function setCurrentSubscriptionPlanName(planName) {
  return {
    type: SETTING_BILLING_SET_CURRENT_SUBSCRIPTION_PLAN_NAME,
    payload: { planName },
  };
}

export function setCountFeatureSubscription(countFeatureSubscription) {
  return {
    type: SETTING_BILLING_SET_COUNT_FEATURE_SUBSCRIPTION,
    payload: { countFeatureSubscription },
  };
}

export function onClickCancelSubscriptionModal(featureSubscriptionModalData) {
  return {
    type: SETTING_BILLING_ON_CLICK_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: { featureSubscriptionModalData },
  };
}

export function setCancelSubsciptionModalData(featureSubscriptionModalData) {
  return {
    type: SETTING_BILLING_SET_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
    payload: { featureSubscriptionModalData },
  };
}

export function showCancelSubscriptionModal() {
  return {
    type: SETTING_BILLING_SHOW_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  };
}

export function hideCancelSubscriptionModal() {
  return {
    type: SETTING_BILLING_HIDE_CANCEL_FEATURE_SUBSCRIPTION_MODAL,
  };
}

export function featureSubscriptionPrice() {
  return {
    type: SETTING_BILLING_FEATURE_SUBSCRIPTION_PRICE,
  };
}

export function setFeatureSubscriptionPrice(featureSubscriptionPrice) {
  return {
    type: SETTING_BILLING_SET_FEATURE_SUBSCRIPTION_PRICE,
    payload: { featureSubscriptionPrice },
  };
}

export function cancelFeatureSubscription(
  featureName,
  featureSubscriptionStatus,
  outletMinMaxDate,
  business
) {
  return {
    type: SETTING_BILLING_CANCEL_FEATURE_SUBSCRIPTION,
    payload: {
      featureName,
      featureSubscriptionStatus,
      outletMinMaxDate,
      business,
    },
  };
}

export function setMinMaxDate(minMaxDate) {
  return {
    type: SETTING_BILLING_SET_MIN_MAX_EXPIRATION_DATE,
    payload: { minMaxDate },
  };
}

export function onClickTurnButton(id, prevIsDeleted, prevIsProrated) {
  return {
    type: SETTING_BILLING_ON_CLICK_TURN_BUTTON,
    payload: { id, prevIsDeleted, prevIsProrated },
  };
}
export function setShowProratedText(showProrate) {
  return {
    type: SETTING_BILLING_SHOW_PRORATE_TEXT,
    payload: { showProrate },
  };
}

export function setIsDeletedOutlet(isDeleted) {
  return {
    type: SETTING_BILLING_SET_IS_DELETED_OUTLET,
    payload: { isDeleted },
  };
}

export function verifyCouponBilling(coupon) {
  return {
    type: SETTING_BILLING_VERIFY_BILLING_COUPON,
    payload: { coupon },
  };
}

export function verifyCouponBillingV2(params) {
  return {
    type: SETTING_BILLING_VERIFY_BILLING_COUPON_V2,
    payload: { params },
  };
}

export function setIsCouponValid(isCouponValid) {
  return {
    type: SETTING_BILLING_SET_STATUS_VALIDATION_COUPON,
    payload: { isCouponValid },
  };
}

export function setCouponDiscount(couponDiscount) {
  return {
    type: SETTING_BILLING_SET_COUPON_DISCOUNT,
    payload: { couponDiscount },
  };
}

export function setCouponDiscountRequest(couponDiscountRequest) {
  return {
    type: SETTING_BILLING_SET_COUPON_DISCOUNT_REQUEST,
    payload: { couponDiscountRequest },
  };
}

export function setCouponErrorMessage(errorMessage) {
  return {
    type: SETTING_BILLING_SET_COUPON_ERROR_MESSAGE,
    payload: { errorMessage },
  };
}

export function isValidatingCoupon(isValidating) {
  return {
    type: SETTING_BILLING_IS_VALIDATING_COUPON,
    payload: { isValidating },
  };
}

export function setPurchasedStaffs(purchasedStaffs) {
  return {
    type: SETTING_BILLING_SET_PURCHASED_STAFFS,
    payload: { purchasedStaffs },
  };
}

export function setIsExtendedStaffSlots(isExtended) {
  return {
    type: SETTING_BILLING_SET_IS_EXTENDED_STAFF_SLOTS,
    payload: { isExtended },
  };
}

export function onClickUpdateIsActiveSubcription(
  outletId,
  prevIsActive,
  currentRules,
  expired,
  rules,
  staff,
  outlets,
  showModal
) {
  return {
    type: SETTING_BILLING_ON_CLICK_ACTIVE_SUBSCRIPTION,
    payload: {
      outletId,
      prevIsActive,
      currentRules,
      expired,
      rules,
      staff,
      outlets,
      showModal,
    },
  };
}

export function onSetActiveSubcription(params) {
  return {
    type: SETTING_BILLING_UPDATE_IS_ACTIVE_SUBCRIPTIONS,
    payload: { paramsDeactive: params },
  };
}

export function setSeparateOutlet(separateOutlet) {
  return {
    type: SETTING_BILLING_SET_SEPARATE_OUTLET,
    payload: { separateOutlet },
  };
}
export function setProgressCursor(isProgress) {
  return {
    type: SETTING_BILLING_SET_PROGRESS_CURSOR,
    payload: { isProgress },
  };
}
export function setExtendDate(extendDate) {
  return {
    type: SETTING_BILLING_SET_EXTEND_DATE,
    payload: { extendDate },
  };
}

export function setminMaxAllOutlet(minMaxAllOutlet) {
  return {
    type: SETTING_BILLING_EXPIRED_DATE,
    payload: { minMaxAllOutlet },
  };
}

export function showMarkSubscriptionModal(
  outletId,
  prevIsActive,
  currentRules,
  expired,
  rules,
  staff,
  outlets,
  showModal
) {
  return {
    type: SETTING_BILLING_SET_SHOW_SUBSCRIPTION_MODAL,
    payload: {
      params: {
        outletId,
        prevIsActive,
        currentRules,
        expired,
        rules,
        staff,
        outlets,
        showModal,
      },
    },
  };
}

export function hideMarkSubscriptionModal() {
  return {
    type: SETTING_BILLING_SET_HIDE_SUBSCRIPTION_MODAL,
  };
}

export function setTotalOutletPrice(totalOutletPrice) {
  return {
    type: SETTING_BILLING_SET_TOTAL_OUTLET_PRICE,
    payload: { totalOutletPrice },
  };
}

export function setTotalFeaturePrice(totalFeaturePrice) {
  return {
    type: SETTING_BILLING_SET_TOTAL_FEATURES_PRICE,
    payload: { totalFeaturePrice },
  };
}

export function setShowSlotEmployee(showSlotEmployee) {
  return {
    type: SETTING_BILLING_SET_SHOW_EMPLOYEE_SLOT,
    payload: { showSlotEmployee },
  };
}

export function sendClevertapBillingInfoOnPageLoad(
  totalOutletPrice,
  outlets,
  currentSubscriptionRules
) {
  return {
    type: SETTING_BILLING_SEND_CLEVERTAP,
    payload: { totalOutletPrice, outlets, currentSubscriptionRules },
  };
}

export function setProratePricePeriods(proratePricePeriods) {
  return {
    type: SETTING_BILLING_SET_PRORATE_PRICE_PERIODS,
    payload: { proratePricePeriods },
  };
}

export function setStaffSlotsPrice(staffSlotsPrice) {
  return {
    type: SETTING_BILLING_SET_STAFF_SLOTS_PRICE,
    payload: { staffSlotsPrice },
  };
}
